var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSavetime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_167_133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.459 14.1785C25.3327 14.1785 26.041 13.4702 26.041 12.5965V10.0547C26.041 9.18098 25.3327 8.47266 24.459 8.47266C23.5853 8.47266 22.877 9.18098 22.877 10.0547V12.5965C22.877 13.4702 23.5853 14.1785 24.459 14.1785Z",
    fill: "#36B37E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.459 39.8203C23.5853 39.8203 22.877 40.5286 22.877 41.4023V43.9441C22.877 44.8178 23.5853 45.5262 24.459 45.5262C25.3327 45.5262 26.041 44.8178 26.041 43.9441V41.4023C26.041 40.5286 25.3328 39.8203 24.459 39.8203Z",
    fill: "#36B37E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0555 25.418H7.51367C6.63997 25.418 5.93164 26.1263 5.93164 27C5.93164 27.8737 6.63997 28.582 7.51367 28.582H10.0555C10.9292 28.582 11.6375 27.8737 11.6375 27C11.6375 26.1263 10.9292 25.418 10.0555 25.418Z",
    fill: "#36B37E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3534 25.4164H26.041V19.373C26.041 18.4993 25.3327 17.791 24.459 17.791C23.5853 17.791 22.877 18.4993 22.877 19.373V26.9984C22.877 27.8721 23.5853 28.5805 24.459 28.5805H30.3534C31.2271 28.5805 31.9355 27.8721 31.9355 26.9984C31.9355 26.1247 31.2271 25.4164 30.3534 25.4164Z",
    fill: "#36B37E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5622 14.8659L13.5972 13.9009C12.9794 13.283 11.9777 13.283 11.3599 13.9009C10.742 14.5187 10.742 15.5204 11.3599 16.1382L12.3249 17.1032C12.9425 17.721 13.9444 17.7212 14.5622 17.1032C15.1802 16.4854 15.1802 15.4838 14.5622 14.8659Z",
    fill: "#36B37E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5913 36.895C35.9736 36.2772 34.9718 36.2772 34.354 36.895C33.7362 37.5129 33.7362 38.5145 34.354 39.1323L35.319 40.0974C35.9367 40.7151 36.9385 40.7153 37.5564 40.0974C38.1742 39.4795 38.1742 38.4779 37.5564 37.8601L36.5913 36.895Z",
    fill: "#36B37E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.319 13.9009L34.354 14.8659C33.7362 15.4838 33.7362 16.4854 34.354 17.1032C34.9716 17.721 35.9735 17.7212 36.5913 17.1032L37.5564 16.1382C38.1742 15.5204 38.1742 14.5187 37.5564 13.9009C36.9385 13.283 35.9368 13.283 35.319 13.9009Z",
    fill: "#36B37E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5972 40.0974L14.5622 39.1323C15.18 38.5145 15.18 37.5129 14.5622 36.895C13.9445 36.2772 12.9427 36.2772 12.3249 36.895L11.3599 37.8601C10.742 38.4779 10.742 39.4795 11.3599 40.0974C11.9775 40.7151 12.9793 40.7153 13.5972 40.0974Z",
    fill: "#36B37E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4526 22.2531C46.2367 11.0307 36.321 2.54102 24.4582 2.54102C10.9719 2.54102 0 13.5129 0 26.9992C0 40.4855 10.9719 51.4574 24.4582 51.4574C25.3319 51.4574 26.0402 50.7491 26.0402 49.8754C26.0402 49.0017 25.3319 48.2934 24.4582 48.2934C12.7166 48.2934 3.16406 38.7408 3.16406 26.9992C3.16406 15.2576 12.7166 5.70508 24.4582 5.70508C34.569 5.70508 43.0557 12.7884 45.2185 22.2531H48.4526Z",
    fill: "#36B37E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7939 26.2205C53.5132 25.7246 52.9872 25.418 52.4172 25.418H42.25C41.6801 25.418 41.1541 25.7246 40.8733 26.2205C40.5925 26.7165 40.6002 27.3252 40.8934 27.8139L45.977 36.2865C46.2629 36.763 46.7779 37.0547 47.3335 37.0547C47.8891 37.0547 48.4041 36.763 48.6901 36.2865L53.7737 27.8139C54.0671 27.3252 54.0748 26.7165 53.7939 26.2205Z",
    fill: "#36B37E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavetime);
export default __webpack_public_path__ + "static/media/Save time.b5327623de503454f3e88a3a3ef63c2c.svg";
export { ForwardRef as ReactComponent };